import { render, staticRenderFns } from "./TemplateModal.vue?vue&type=template&id=25fed21f&scoped=true"
import script from "./TemplateModal.vue?vue&type=script&lang=ts"
export * from "./TemplateModal.vue?vue&type=script&lang=ts"
import style0 from "./TemplateModal.vue?vue&type=style&index=0&id=25fed21f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fed21f",
  null
  
)

export default component.exports